/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

export function ZetaSection(props) {
  const activeSection = (props.app && props.app.activeSection) || props.activeSection || '';
  const { name } = props;

  let hidden = false;
  if (name && activeSection && name !== activeSection) hidden = true;

  return (
    <div className={'row no-print ' + (hidden ? ' d-none' : '')}>
      <div className="col col-lg-12 col-xl-10 offset-xl-1">
        <div className="card m-2">
          <div className="card-header">
            <h6 className="m-0 font-weight-bold text-primary">{props.title}</h6>
          </div>

          <div className="card-body">{props.children}</div>
        </div>
      </div>
    </div>
  );
}
